<template>

    <div class="menu" @mouseleave="$emit('close')">
        <div class="menu-body">
            <div class="arrow"></div>
            <a href="#" class="menu-link" v-for="item in items" :key="item.slug" @click.prevent="push(item.slug)">
                <i class="icon" :class="item.icon" />
                <div class="info">
                    <div class="title">{{ item.title }}</div>
                    <div class="subtitle">{{ item.subtitle }}</div>
                </div>
            </a>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .menu {
        background: #fff;
        border-radius: 5px;
        box-shadow: 0 10px 50px rgba(0,0,0,0.3);
        left: 0;
        margin: 50px 0 0 0;
        position: absolute;
        top: 0;
        width: 300px;
    }

    .menu-body {
        display: grid;
        gap: 15px;
        padding: 30px;
        position: relative;
        .arrow {
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #fff;
            margin: -10px 0 0 20px;
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .menu-link {
        align-items: top;
        display: flex;
        text-decoration: none;
        &:hover {
            .title, .subtitle {
                color: $color-link-hover;
            }
        }
        .icon {
            color: $color-link;
            font-size: 16px;
            margin-right: 15px;
            padding: 2px 0;
            transition: color .3s;
        }
        .title {
            @include font-semibold(14px);
            color: $color-text;
            line-height: 1.4em;
            transition: color .3s;
        }
        .subtitle {
            @include font-medium(13px);
            color: $color-text;
            line-height: 1.4em;
            transition: color .3s;
        }
    }

</style>

<script>

export default {

    props: {
        direction: {
            type: String,
            default: 'down',
        },
    },

    data() {
        return {
            items: [
                {
                    'slug': 'feature-engagement',
                    'icon': 'fas fa-paper-plane',
                    'title': 'Customer Engagement',
                    'subtitle': 'Behavior-based automations',
                },
                {
                    'slug': 'feature-management',
                    'icon': 'fas fa-id-card',
                    'title': 'Customer Management',
                    'subtitle': 'Real-time customer activity',
                },
                {
                    'slug': 'feature-segmenting',
                    'icon': 'fas fa-chart-pie',
                    'title': 'Customer Segmenting',
                    'subtitle': 'Segment customers into lists',
                },
                {
                    'slug': 'feature-email',
                    'icon': 'fas fa-envelope-open-text',
                    'title': 'Email Builder',
                    'subtitle': 'Drag-and-drop builder',
                },
            ]
        }
    },

    methods: {

        push(slug) {
            this.$router.push({ 'name': slug });
            this.$emit('close');
        }

    },

}

</script>
